export default "__VITE_ASSET__BDjbrqMH__"